"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const material_1 = require("@mui/material");
const Grid_1 = __importDefault(require("@mui/material/Grid"));
const Add_1 = __importDefault(require("@mui/icons-material/Add"));
const DeleteForever_1 = __importDefault(require("@mui/icons-material/DeleteForever"));
const system_1 = require("@mui/system");
const InfoPopup_1 = require("./InfoPopup");
const formik_1 = require("formik");
const StyledTextField = (0, material_1.styled)(material_1.TextField)(() => ({
    '& input': {
        height: '30px',
    },
}));
const StyledError = (0, material_1.styled)(material_1.Typography)(({ theme }) => ({
    marginTop: theme.spacing(1),
    color: theme.palette.error.main,
    fontSize: '16px',
}));
const CustomUserDefined = ({ field, name, error }) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [formikField, meta, helpers] = (0, formik_1.useField)(name);
    const { setValue } = helpers;
    const { value } = formikField;
    const defaultData = typeof field.rowDefault === 'object' && field.rowDefault !== null
        ? field.rowDefault
        : { text: '', type: 'percent', value: 0 };
    const [shouldReveal, setShouldReveal] = (0, react_1.useState)(Boolean(value && Array.isArray(value) && value.length));
    const handleClickReveal = () => {
        if (!shouldReveal) {
            setValue([defaultData]);
            setShouldReveal(true);
        }
        else {
            setValue([]);
            setShouldReveal(false);
        }
    };
    const handleTextChange = (index, newValue) => {
        const updatedRowData = [...value];
        updatedRowData[index] = Object.assign(Object.assign({}, updatedRowData[index]), { text: newValue });
        setValue(updatedRowData);
    };
    const handleTypeChange = (index, newValue) => {
        if (!newValue)
            return;
        const updatedRowData = [...value];
        updatedRowData[index] = Object.assign(Object.assign({}, updatedRowData[index]), { type: newValue });
        setValue(updatedRowData);
    };
    const handleValueChange = (index, newValue) => {
        const updatedValue = newValue === '' ? null : Number(newValue);
        const updatedRowData = [...value];
        updatedRowData[index] = Object.assign(Object.assign({}, updatedRowData[index]), { value: updatedValue });
        setValue(updatedRowData);
    };
    const handleRemoveRow = (index) => {
        if (value.length === 1) {
            setValue([defaultData]);
            return;
        }
        const updatedRowData = [...value];
        updatedRowData.splice(index, 1);
        setValue(updatedRowData);
    };
    const handleAddRow = () => {
        setValue([...value, defaultData]);
    };
    const label = field.info ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [field.label, (0, jsx_runtime_1.jsx)(InfoPopup_1.InfoPopup, { popId: field.attribute, infos: [field.info] })] })) : (field.label);
    return ((0, jsx_runtime_1.jsxs)(system_1.Box, { sx: { marginBottom: 2 }, children: [(0, jsx_runtime_1.jsx)(material_1.FormControlLabel, { control: (0, jsx_runtime_1.jsx)(material_1.Checkbox, { checked: shouldReveal, onChange: handleClickReveal }), label: label }), shouldReveal && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(Grid_1.default, { container: true, spacing: 2, mb: 1, alignItems: "stretch", children: [(0, jsx_runtime_1.jsx)(Grid_1.default, { item: true, md: 5, children: (0, jsx_runtime_1.jsx)(material_1.FormLabel, { children: "Name" }) }), (0, jsx_runtime_1.jsx)(Grid_1.default, { item: true, md: 2, children: (0, jsx_runtime_1.jsx)(material_1.FormLabel, { children: "Type" }) }), (0, jsx_runtime_1.jsx)(Grid_1.default, { item: true, md: 4, children: (0, jsx_runtime_1.jsx)(material_1.FormLabel, { children: "Value" }) })] }), value.map((row, index) => (
                    // <StyledBox key={`${field.attribute}_${index}`}>
                    (0, jsx_runtime_1.jsxs)(Grid_1.default, { container: true, spacing: 1, mb: 2, alignItems: "stretch", children: [(0, jsx_runtime_1.jsx)(Grid_1.default, { item: true, md: 5, children: (0, jsx_runtime_1.jsx)(StyledTextField, { variant: "standard", inputProps: { maxLength: 40 }, fullWidth: true, value: row.text, onChange: (e) => handleTextChange(index, e.target.value) }) }), (0, jsx_runtime_1.jsx)(Grid_1.default, { item: true, md: 2, children: (0, jsx_runtime_1.jsxs)(material_1.ToggleButtonGroup, { value: row.type, exclusive: true, onChange: (event, newValue) => handleTypeChange(index, newValue), "aria-label": "discount type", sx: { width: '100%' }, children: [(0, jsx_runtime_1.jsx)(material_1.ToggleButton, { value: "percent", "aria-label": "percent", sx: {
                                                fontSize: '1rem',
                                                padding: '4px 4px',
                                                width: '50%',
                                            }, children: "%" }), (0, jsx_runtime_1.jsx)(material_1.ToggleButton, { value: "amount", "aria-label": "amount", sx: {
                                                fontSize: '1rem',
                                                padding: '4px 4px',
                                                width: '50%',
                                            }, children: "$" })] }) }), (0, jsx_runtime_1.jsx)(Grid_1.default, { item: true, md: 4, children: (0, jsx_runtime_1.jsx)(StyledTextField, { variant: "standard", inputProps: { min: 0, step: '0.01' }, fullWidth: true, type: "number", value: row.value, onChange: (e) => handleValueChange(index, e.target.value), InputProps: {
                                        startAdornment: row.type === 'amount' ? ((0, jsx_runtime_1.jsx)(material_1.InputAdornment, { position: "start", children: "$" })) : null,
                                        endAdornment: row.type === 'percent' ? ((0, jsx_runtime_1.jsx)(material_1.InputAdornment, { position: "end", children: "%" })) : null,
                                    } }) }), (0, jsx_runtime_1.jsx)(Grid_1.default, { item: true, md: 1, children: (0, jsx_runtime_1.jsx)(Grid_1.default, { item: true, md: 1, children: (0, jsx_runtime_1.jsx)(material_1.IconButton, { onClick: () => handleRemoveRow(index), children: (0, jsx_runtime_1.jsx)(DeleteForever_1.default, { sx: { fontSize: '1.5rem' } }) }) }) })] }, `${field.attribute}_${index}`))), error && (0, jsx_runtime_1.jsx)(StyledError, { children: error }), (0, jsx_runtime_1.jsx)(Grid_1.default, { container: true, spacing: 2, alignItems: "stretch", children: (0, jsx_runtime_1.jsx)(Grid_1.default, { item: true, md: 2, children: (0, jsx_runtime_1.jsx)(material_1.IconButton, { onClick: handleAddRow, color: "primary", sx: {
                                    backgroundColor: 'primary.main',
                                    padding: 0,
                                    borderRadius: 0,
                                    color: 'white',
                                    '&:hover': {
                                        backgroundColor: 'primary.dark',
                                    },
                                }, children: (0, jsx_runtime_1.jsx)(Add_1.default, {}) }) }) })] }))] }, field.attribute));
};
exports.default = CustomUserDefined;
